import ProjectsList from '../assets/projects.json'
import type WikiDoc from "@/entities/WikiDoc";
import type TimelineProject from "@/entities/TimelineProject";

interface StoreState {
    projects: any[]
    getProjectInfo: (projectName: string) => any
    wikiDocuments: WikiDoc[]
    saveWikiDocument: (doc: WikiDoc) => void,
    updateWikiDocument: (id: string, updatedDoc: WikiDoc) => void,
    getWikiDocument: (name: string) => WikiDoc | undefined,
    deleteWikiDocument: (id: string) => void,
    timelineProjects: TimelineProject[]
    saveTimelineProject: (project: TimelineProject) => void,
    updateTimelineProject: (id: string, updatedProject: TimelineProject) => void,
    deleteTimelineProject: (id: string) => void,
}

const store: StoreState = {
    projects: ProjectsList,
    getProjectInfo: (projectName: string) => {
      return store.projects.find(proj => proj.name === projectName)
    },

    wikiDocuments: [],
    saveWikiDocument: (doc: WikiDoc) => {
        store.wikiDocuments.push(doc)
    },
    updateWikiDocument: (id: string, updatedDoc: WikiDoc) => {
        const docIndex = store.wikiDocuments.findIndex(doc => doc._id === id);
        store.wikiDocuments[docIndex] = updatedDoc
    },
    getWikiDocument: (name: string) => {
        return store.wikiDocuments.find(doc => doc.name === name)
    },
    deleteWikiDocument: (id: string) => {
        store.wikiDocuments = store.wikiDocuments.filter(doc => doc._id !== id)
    },

    timelineProjects: [],
    saveTimelineProject: (project: TimelineProject) => {
        store.timelineProjects.push(project)
    },
    updateTimelineProject: (id: string, updatedProject: TimelineProject) => {
        const idx = store.timelineProjects.findIndex(p => p._id === id)
        if (idx !== -1) store.timelineProjects[idx] = updatedProject
    },
    deleteTimelineProject: (id: string) => {
        store.timelineProjects = store.timelineProjects.filter(p => p._id !== id)
    },
}


export default store
